<app-player-profile-overview-header/>

<router-outlet/>
